import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class PostNewsCommentReviewsUseCase extends UseCase {
  constructor({config, newsPostCommentRequestValueObjectFactory, repository, getCurrentUserService}) {
    super()

    this._config = config
    this._repository = repository
    this._newsPostCommentRequestValueObjectFactory = newsPostCommentRequestValueObjectFactory
    this._getCurrentUserService = getCurrentUserService
  }

  @tracer({metric: 'PostNewsCommentReviewsUseCase#execute'})
  @inlineError
  async execute({articleId, comment, commentId}) {
    const userEntity = await this._getCurrentUserService.execute()

    const requestVO = this._newsPostCommentRequestValueObjectFactory({
      articleId,
      comment,
      commentId,
      userEntity
    })
    const [postNewsCommentError, postNewsCommentResponse] = await this._repository.postComment(requestVO)

    return postNewsCommentError ? Promise.reject(postNewsCommentError) : postNewsCommentResponse.toJSON()
  }
}
